export const FORM_FIELDS = {
  LANGUAGE: 'language',
  CONTENT_BODY: 'content_body',
  BODY: 'body',
  IMGS: 'imgs',
  VIDEOS: 'videos',
  WEBSITES: 'websites',
  INTERNAL_INFORMATION: 'internal_information',
  LIVE_URLS: 'live_urls',
  CONTENT_IDS: 'content_ids',
  ARTICLE_VERSION_LIST: 'article_version_list',
  NEXT_STATES: 'next_states',
  SURTITLES: 'surtitles',
  EDITION_LANGUAGE: 'edition_language',
  TYPED_TAGS: 'typed_tags',
  TOPICS: 'topics',
  TOPICS_WITH_TRANSLATIONS: 'topics_with_translations',
  TAGS: 'tags',
  COMPANIES: 'companies',
  PEOPLE: 'people',
  PUBLISH: 'publish',
  DATE: 'date',
  TIMEZONE: 'timezone',
  SHOW_PUBLISH_TIME: 'show_publish_time',
  SELECTED_AUTHORS: 'selected_authors',
  RESTRICTED_TO_REGISTERED_USERS: 'restrict_to_registered_users',
  NOT_FOR_GOOGLE_NEWS_SITEMAPS: 'not_for_google_news_sitemaps',
  NOT_FOR_NEWS_FEED: 'not_for_news_feeds',
  HIDE_THIS_ARTICLE: 'hide_this_article',
  PAYWALL_PREMIUM_CONTENT: 'paywall_premium_content',
  NOT_FOR_COMPETITORS: 'not_for_competitors',
  CONTENT_SET_HEADLINE: 'content_set_headline',
  STRAPLINE: 'strapline',
  EDITORSNOTE: 'editors_note',
  BANNER_IMAGE: 'banner_image',
  SPONSOR_LOGOS: 'sponsor_logos',
  PRIMARY_COLOUR_HEX: 'primary_colour_hex',
  SECONDARY_COLOUR_HEX: 'secondary_colour_hex',
  HIGHLIGHT_COLOUR_HEX: 'highlight_colour_hex',
  CHAPTERS: 'chapters',
  LANDING_PAGE_HEADLINE: 'landing_page_headline',
  HEADLINE: 'headline',
  MAIN_IMAGE: 'main_image',
  MAIN_VIDEO: 'main_video',
  DISPLAY_IMAGE_ON_WEBSITE: 'display_image_on_website',
};
